import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { TableRow } from '@material-ui/core';
import Swal from 'sweetalert2';
import * as Utils from '../../commons/utils/Utils';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

/**
 * El nombre del tarifario es texto libre y el modal de baja lo inyecta con la opción `html` de
 * SweetAlert2, que interpreta HTML: sin escapar sería XSS almacenado. Mismo criterio que
 * InventarioManoObraGridRow. La grilla no lo necesita porque React escapa lo que renderiza.
 */
const escapeHtml = (s) =>
  String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const InventarioTarifariosGridRow = (props) => {
  const intl = props.intl;
  const row = props.row;
  const baseUrl = props.baseUrl;
  const proveedores = row.proveedores || [];
  const [redirectTo, setRedirectTo] = useState(null);

  /**
   * Baja lógica. Si tiene proveedores se avisa cuántos quedan sin tarifario y que pasan a usar los
   * precios del Catálogo de Ítems: es lo que hace el backend en la misma transacción.
   */
  const handleDesactivar = () => {
    let html =
      intl.formatMessage({
        id: 'inventarioTarifarios.desactivar.se_dara_de_baja',
        defaultMessage: 'Se dará de baja el tarifario',
      }) +
      ': <b>' +
      escapeHtml(row.nombre || '') +
      '</b>';
    if (proveedores.length > 0) {
      html +=
        '<br/>' +
        intl.formatMessage(
          {
            id: 'inventarioTarifarios.desactivar.dejara_sin_tarifario',
            defaultMessage:
              'Va a dejar sin tarifario a {cantidad, plural, one {# proveedor, que pasará} other {# proveedores, que pasarán}} a usar los precios del Catálogo de Ítems.',
          },
          { cantidad: proveedores.length }
        );
    }

    Swal.fire({
      title: intl.formatMessage({
        id: 'inventarioTarifarios.desactivar.confirma',
        defaultMessage: '¿Confirma la baja del tarifario?',
      }),
      html: html,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({ id: 'yes', defaultMessage: 'Si' }),
      cancelButtonText: intl.formatMessage({ id: 'no', defaultMessage: 'No' }),
    }).then((result) => {
      if (result.value) {
        Utils.sendData('/inventario/tarifarios/' + row.id + '/desactivar', 'PUT', {})
          .then(() => {
            props.fetchRows();
            Swal(
              intl.formatMessage({ id: 'inventarioTarifarios.desactivar.dado_de_baja', defaultMessage: 'Dado de baja!' }),
              '',
              'success'
            );
          })
          .catch((err) => {
            Swal(err && err.getMessage ? err.getMessage() : 'Error', '', 'error');
          });
      }
    });
  };

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      <TableRow>
        <StyledTableCell align="left">{row.nombre}</StyledTableCell>
        <StyledTableCell align="left">{row.descripcion || '-'}</StyledTableCell>
        <StyledTableCell align="left">
          {proveedores.length > 0 ? (
            <>
              <b>{proveedores.length}</b>
              {' · '}
              {proveedores.map((p) => p.razonSocial).join(', ')}
            </>
          ) : (
            intl.formatMessage({ id: 'inventarioTarifarios.grid.sin_proveedores', defaultMessage: 'Sin proveedores' })
          )}
        </StyledTableCell>
        <StyledTableCell align="left">
          {row.ultimaModificacion ? LocaleFormat.formatDateTime(row.ultimaModificacion) : '-'}
        </StyledTableCell>
        <StyledTableCell>
          <div className="d-inline-flex">
            {props.permissions.visualizar && (
              <button
                className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                title={intl.formatMessage({ id: 'Ver', defaultMessage: 'Ver' })}
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + row.id)}
              >
                <i className="fa fa-search fa-xs" />
              </button>
            )}
            {props.permissions.modificar && (
              <button
                className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                title={intl.formatMessage({ id: 'Editar', defaultMessage: 'Editar' })}
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + row.id + '/edit')}
              >
                <i className="fa fa-pencil fa-xs" />
              </button>
            )}
            {props.permissions.desactivar && (
              <button
                className="action delete btn btn-sm btn-icon btn-dt-grid text-danger"
                title={intl.formatMessage({ id: 'inventarioTarifarios.grid.dar_de_baja', defaultMessage: 'Dar de baja' })}
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => handleDesactivar()}
              >
                <i className="fa fa-trash fa-xs" />
              </button>
            )}
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
};

export default InventarioTarifariosGridRow;
